import { FeatureIntroductionPagePresenter } from "@/presenters/featureIntroduction/FeatureIntroductionPagePresenter";
import { FeatureIntroductionVersionPresenter } from '@/presenters/featureIntroduction/FeatureIntroductionVersionPresenter'

export class FeatureIntroductionPresenter {
    constructor(form) {
        this.platform = new FeatureIntroductionVersionPresenter(form.platform);
        this.pageList = form.pageList.map(page => new FeatureIntroductionPagePresenter(page));
    }
}



// WEBPACK FOOTER //
// ./src/presenters/featureIntroduction/FeatureIntroductionPresenter.js